import React__default from 'react';

/* eslint-disable @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any */

/** Fixed forwardRef that works correctly with generic components */
function forwardRef(render) {
  return /*#__PURE__*/React__default.forwardRef(render);
}

/**
 * Returns true if `node` is null/undefined, false, empty string, or an array
 * composed of those. If `node` is an array, only one level of the array is
 * checked, for performance reasons.
 */
function isReactNodeEmpty(node, skipArray = false) {
  return node == null || node === '' || node === false || !skipArray && Array.isArray(node) && (
  // only recurse one level through arrays, for performance
  node.length === 0 || node.every(n => isReactNodeEmpty(n, true)));
}

/**
 * Returns true if the given JSX element matches the given component type.
 *
 * NOTE: This function only checks equality of `displayName` for performance and
 * to tolerate multiple minor versions of a component being included in one
 * application bundle.
 *
 * @param element JSX element in question
 * @param ComponentType desired component type of element
 */
function isElementOfType(element, ComponentType) {
  return element != null && element.type != null && element.type.displayName != null && element.type.displayName === ComponentType.displayName;
}

export { forwardRef, isElementOfType, isReactNodeEmpty };
